import { FormControl, FormField, FormItem, FormLabel, FormMessage, InputMask, useFormContext } from '@cobliteam/ui/form';
import type { FormValues } from '../validationSchema';

const DriverPhoneInput = () => {
  const { setValue } = useFormContext<FormValues>();

  return (
    <FormField name='phoneNumbers'>
      {({ field }) => {
        const handlePhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const eventValue = event.target.value;
          setValue('phoneNumbers', [eventValue], {
            shouldValidate: true,
            shouldDirty: true,
          });
        };

        return (
          <FormItem className='w-full space-y-1'>
            <FormLabel>Contato</FormLabel>
            <FormControl>
              <InputMask
                name='phoneNumbers'
                mask='(__) _____-____'
                replacement={{ _: /\d/ }}
                onChange={handlePhoneChange}
                value={field.value[0] || ''}
                placeholder='(DDD) Número do celular'
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    </FormField>
  );
};

export default DriverPhoneInput;
